import React, { Component } from 'react'
import { message, Table, Tooltip, Modal, Pagination, Button } from 'antd'
import moment from 'moment'
import {  BreadcrumbLink } from '../components'
import FilePreview, { FileType, PreviewInfo } from '../../../components/common/FilePreview'
import * as GLOBAL from '../../../utils/global'
import * as API from '../../../api'
import { connect } from 'react-redux'
import { HeaderSearch } from '../components/index'
import './index.less'
const { confirm } = Modal
const approveDict = {
	10: { text: "提交-待审核", color: "#f7af23" },
	20: { text: "品牌初审-通过", color: "#1dc11d" },
	25: { text: "品牌初审-驳回", color: "#f23c3c" },
	30: { text: "品牌终审-通过", color: "#1dc11d" },
	35: { text: "品牌终审-驳回", color: "#f23c3c" },
	40: { text: "法务终审-通过", color: "#1dc11d" },
	45: { text: "法务终审-驳回", color: "#f23c3c" },
}
class NewMedia extends Component<any> {
	state = {
		btnAuth: [],
		selectedRowKeys: [], // 批量选择 key
		selectedRow: [], // 批量选择 row
		dataList: [], // 表数据
		idMap: {},
		previewVisible: false,
		previewInfo: {
			content: '',
			type: '文章',
		},
		pagination: {
			pageSize: 50,
			total: 50,
			pageSizeOptions: [50, 100, 150, 200],
			current:1,
			onShowSizeChange: this.sizeChange.bind(this),
			onChange: this.changePageNo.bind(this)
		},
		queryBody: {
			pageNum: '1',
			pageSize: '50',
			stPbl: 2
		},
	}
	/**
	 * 获取按钮权限
	 */
	getBtnAuth = () => {
		const routePath = this.props.route.path
		// const path = this.state.pageTitle === '作品列表' ? routePath : (routePath.endsWith('/index') ? routePath.replace(/(\/index)$/g,'') : routePath)
		GLOBAL.getChildAuth(routePath).then((res: AuthProps[]) => {
			const functionAuth = res.map(item => item.resourceVal)
			console.log(functionAuth)
			this.setState({
				btnAuth: functionAuth
			},() => {
				this.getSearch({})
			})
		})
	}
	onSelectChange = (selectedRowKeys: string, selectedRow) => {
		console.log('selectedRowKeys changed: ', selectedRowKeys, selectedRow)
		this.setState({ selectedRowKeys, selectedRow })
	}
	componentDidMount() {
		this.getContentType()
		this.getSearch({})
		this.getBtnAuth()
	}
	sizeChange(val, size) {
		this.removeJumpBeforeRecord()
		localStorage.setItem('jumpBeforepageSize', size)
		const { pagination, queryBody } = this.state
		pagination.pageSize = size
		pagination.current = 1
		queryBody.pageNum = '1'
		queryBody.pageSize = size
		this.setState({
			pagination,
			queryBody
		}, () => {
			this.getSearch({})
		})
	}
	changePageNo(val) {
		const { pagination, queryBody } = this.state
		this.removeJumpBeforeRecord()
		queryBody.pageNum = val + ''
		pagination.current = val
		this.setState({
			pagination,
			queryBody
		}, () => {
			this.getSearch({})
		})
	}
	jumpBeforeRecord() {
		localStorage.setItem('jumpBeforepageNo', this.state.queryBody.pageNum)
		localStorage.setItem('jumpBeforeScrollTop', document.getElementById('basic-layout-content').scrollTop + '')
	}
	removeJumpBeforeRecord() {
		localStorage.removeItem('jumpBeforepageNo')
		localStorage.removeItem('jumpBeforeScrollTop')
	}
	async getContentType() {
		const idMap = await GLOBAL.getContentType('idMap')
		this.setState({
			idMap
		})
	}
	async getSearch(params?) {
		console.log('getSearch params',params)
		const { queryBody, pagination } = this.state
		const jumpBeforeParams = localStorage.getItem('jumpBeforeParams')
		const jumpBeforepageNo = localStorage.getItem('jumpBeforepageNo')
		const jumpBeforeScrollTop = localStorage.getItem('jumpBeforeScrollTop')
		const jumpBeforepageSize = localStorage.getItem('jumpBeforepageSize')
		let body = {}
		if(JSON.stringify(params) !== '{}') {
			queryBody.pageNum = '1'
			pagination.current = 1
			body = JSON.parse(JSON.stringify({...params, ...queryBody}))
			// 审核/编辑/日志/删除/详情等 跳转前页面前记录当前搜索值
			localStorage.setItem('jumpBeforeParams', JSON.stringify(params))
		} else if(jumpBeforeParams !== null || jumpBeforepageNo !== null || jumpBeforepageSize !== null) {
			if(jumpBeforeParams !== null) params = JSON.parse(jumpBeforeParams)
			if(jumpBeforepageNo !== null) {
				queryBody.pageNum = jumpBeforepageNo
				pagination.current = Number(jumpBeforepageNo)
			}
			if(jumpBeforepageSize !== null) {
				pagination.pageSize = Number(jumpBeforepageSize)
				queryBody.pageSize = jumpBeforepageSize
			}
			body = JSON.parse(JSON.stringify({...params, ...queryBody}))
			console.log('缓存====================',jumpBeforeParams,jumpBeforepageNo,jumpBeforeScrollTop,document.getElementById('basic-layout-content').scrollTop)
		} else {
			body = JSON.parse(JSON.stringify(queryBody))
		}

		const { code, result, totalCount } = await API.findList(body)
		if(code === '0000') {
			pagination.total = totalCount
			if(result.length === 0 && queryBody.pageNum !== '1') {
				queryBody.pageNum = '1'
				pagination.current = 1
				this.removeJumpBeforeRecord()
				this.setState({queryBody,pagination},() => {
					this.getSearch({})
				})
			} else {
				this.setState({
					dataList: result,
					queryBody,
					pagination,
				},() => {
					if(jumpBeforeScrollTop !== null) {
						document.getElementById('basic-layout-content').scrollTop = Number(jumpBeforeScrollTop)
					}
				})
			}
		}

		// const { code, msg, data } = await API.selectCheckList(body)
		// if(code === 0) {
		// 	const { list, count } = data
		// 	pagination.total = count
		// 	if(list.length === 0 && queryBody.pageNum !== '1') {
		// 		queryBody.pageNum = '1'
		// 		pagination.current = 1
		// 		this.removeJumpBeforeRecord()
		// 		this.setState({queryBody,pagination},() => {
		// 			this.getSearch({})
		// 		})
		// 	} else {
		// 		this.setState({
		// 			dataList: list,
		// 			queryBody,
		// 			pagination,
		// 		},() => {
		// 			if(jumpBeforeScrollTop !== null) {
		// 				document.getElementById('basic-layout-content').scrollTop = Number(jumpBeforeScrollTop)
		// 			}
		// 		})
		// 	}
		// } else {
		// 	this.setState({
		// 		dataList: []
		// 	})
		// }
	}
	/******  预览相关  ******/
	handlePreview = (info: PreviewInfo) => {
		this.setState({
			previewInfo: info,
		})
		this.handlePreviewVisible(true)
	}
	handlePreviewByDetails = (details) => {
		if(GLOBAL.reviewState[details.st_review] === '视频制作失败' || GLOBAL.reviewState[details.st_review] === '视频制作中') {
			message.info(`${GLOBAL.reviewState[details.st_review]},暂不支持预览`)
			return
		}
		const type = this.state.idMap[details.st_type]
		const content = type === '文章' ? details.st_text_content : details.st_fileurl
		const previewInfo: PreviewInfo = { type, content }
		if (type === '文章') {
			previewInfo.title = details.st_text_title
			previewInfo.author = details.st_author
		}
		this.handlePreview(previewInfo)
	}
	handlePreviewVisible = (val: boolean): void => {
		this.setState({
			previewVisible: val
		})
	}
	render() {
		const {
			previewInfo,
			previewVisible,
			selectedRowKeys,
			selectedRow,
			pagination,
			dataList,
			idMap,
			btnAuth
		} = this.state
		const { userInfo } = this.props
		// 详情
		const getDetails = (id, tab) => {
			this.jumpBeforeRecord()
			this.props.history.push(`/main/content/details/${id}/${tab}`)
		}
		const update = (info) => {
			this.jumpBeforeRecord()
			this.props.history.push(`/main/review/formFilling?id=${info.id}&from=trade`)
		}
		const revokeReview = async (id) => {
			const {code, msg} = await API.revokeReview({ids: [id]})
			if(code === 0) {
				message.info('撤销成功')
				dataList.map(item => {
					if(item.id === id) item.st_review_node = 11
				})
				this.setState({dataList})
			} else {
				message.error((msg))
			}
		}
		const del = (id) => {
			if(!id && selectedRowKeys.length === 0) {
				message.warning('您未选中任何数据')
				return
			}
			const that = this
			confirm({
				title: '提示',
				content: '请确认是否要删除选中的内容',
				okText: '删除',
				icon: null,
				cancelText: '取消',
				onOk() {
					const body = {
						ids: id ? [id] : selectedRowKeys
					}
					API.deleteContent(body).then(res => {
						const { code, msg } =res
						if(code === 0) {
							const { queryBody, pagination, dataList } = that.state
							const pageNo =  Number(queryBody.pageNum)
							const isLastPage = Number(pagination.total)/Number(pagination.pageSize)
							// 最后一页全删试，请求pageNo - 1
							if(dataList.length === body.ids.length && pageNo >=isLastPage) {
								queryBody.pageNum = pageNo > 1 ? pageNo - 1 : pageNo
								pagination.current = Number(queryBody.pageNum)
							}
							that.jumpBeforeRecord()
							that.setState({
								queryBody,
								pagination
							}, () => {
								that.getSearch({})
							})
						} else {
							message.error(msg)
						}
						that.setState({
							selectedRowKeys: []
						})
					})
				},
				onCancel() {
					console.log('Cancel')
				},
			})
		}
		const handleDelete = (id: string) => {
			const that = this
			const body = {
				ids: id ? [id] : selectedRowKeys
			}
			confirm({
				title: '提示',
				content: '请确认是否要删除该项',
				okText: '删除',
				icon: null,
				cancelText: '取消',
				onOk() {
					API.deleteApprove(id).then(res => {
						if (res.code === '0000') {
							message.success('删除成功')
							const { queryBody, pagination, dataList } = that.state
							const pageNo =  Number(queryBody.pageNum)
							const isLastPage = Number(pagination.total)/Number(pagination.pageSize)
							// 最后一页全删试，请求pageNo - 1
							if(dataList.length === body.ids.length && pageNo >=isLastPage) {
								queryBody.pageNum = pageNo > 1 ? pageNo - 1 : pageNo
								pagination.current = Number(queryBody.pageNum)
							}
							that.jumpBeforeRecord()
							that.setState({
								queryBody,
								pagination
							}, () => {
								that.getSearch({})
							})
						} else {
							message.error('删除失败')
						}
					})
				},
				onCancel() {
					console.log('Cancel')
				},
			})
		}
		const addMedia = (): void => {
			this.props.history.push(`/main/review/formFilling?from=trade`)
		}
		const postReview = async (type) => {
			const params = {
				review: type,
				remarks:'',
				comments: '',
				ids:[]
			}
			selectedRow.forEach(item => {
				params.ids.push(item.id)
			})
			const {code, msg} = await API.reviewWorkflow(params)
			if(code === 0) {
				message.info('操作成功')
			} else {
				message.error(msg)
			}
			this.getSearch({})
			Modal.destroyAll()
			this.setState({
				selectedRowKeys: []
			})
		}
		const batchReview = (data) => {
			if(!data) {
				if(selectedRowKeys.length === 0) {
					message.warning('您未选中任何数据')
					return
				} else {
					let flag = false
					selectedRow.forEach(item => {
						if(item.st_review != 'r1') {
							flag = true
							message.warning('当前素材非待审核状态')
						} else {
							if ((item.st_review_node == '6' && !btnAuth.includes('firstTrial()'))||(item.st_review_node == '7' && !btnAuth.includes('endTrial()'))||(item.st_review_node == '3' && !btnAuth.includes('lawWorks()'))||(item.st_review_node == '8' && !btnAuth.includes('wxBrand()'))) {
								flag = true
								message.warning('您没有当前审核权限')
							}
						}
					})
					if(flag) return
				}
				confirm({
					title: '提示',
					content: '是否审核通过？确认后不可更改',
					okText: '通过',
					icon: null,
					cancelText: '不通过',
					onOk() {
						postReview('通过')
					},
					onCancel(value) {
						if(!value.triggerCancel) postReview('不通过')
					},
				})
				// 批量审核
			} else {
				const {id, st_fileurl, st_type,st_review, st_review_node} = data
				// 非待审核状态
				if(st_review !== 'r1') {
					message.warning('当前素材非待审核状态')
					return
				}
				// 无对应审核权限
				if(
					((st_review_node == '6' && !btnAuth.includes('firstTrial()'))||(st_review_node == '7' && !btnAuth.includes('endTrial()'))||(st_review_node == '3' && !btnAuth.includes('lawWorks()'))||(st_review_node == '8' && !btnAuth.includes('wxBrand()')))
				) {
					message.warning('无对应审核权限')
					return
				}
				// 有对应审核权限
				if(
					((st_review_node == '6' && btnAuth.includes('firstTrial()'))||(st_review_node == '7' && btnAuth.includes('endTrial()'))||(st_review_node == '3' && btnAuth.includes('lawWorks()'))||(st_review_node == '8' && btnAuth.includes('wxBrand()')))
				) {
					this.jumpBeforeRecord()
					this.props.history.push(`/review?from=jl&url=${st_fileurl}&type=${st_type}&state=${st_review_node}&id=${id}`)
					return
				}
			}
		}
		const gethandlePreview = async (record) => {
			const { code, data, msg } = await API.getContentInfo({ id: record.id })
			if (code === 0) {
				this.handlePreviewByDetails(data)
			} else {
				message.error(msg)
			}
		}
		const columns= [
			{
				title: '标题',
				dataIndex: 'st_text_title',
				width: 100,
				render: (text: string, record: object) => (
					<Tooltip placement="topLeft" title={text}>
						<div className="title-display">
							<a onClick={() => getDetails(record.id, 1)}>{text}</a>
						</div>
					</Tooltip>
				)
			},
			{
				title: '内容形式',
				dataIndex: 'st_type',
				textWrap: 'word-break',
				width: 90,
				ellipsis: true,
				render: (item: string) => {
					return (
						<span>{JSON.stringify(idMap) !== '{}' ? idMap[item] : ''}</span>
					)
				},
			},
			{
				title: '发布时间/更新时间',
				dataIndex: 'st_create_time',
				textWrap: 'word-break',
				width: 160,
				ellipsis: true,
				render: (time: string, record: object) => {
					return (
						<div>{time.slice(0,-3)}<br></br>{record.st_update_time.slice(0,-3)}</div>
					)
				},
			},
			{
				title: '创建人',
				dataIndex: 'userName',
				width: 80
			},
			// {
			// 	title: '是否通过法务',
			// 	dataIndex: 'st_review_node',
			// 	width: 126,
			// },
			{
				title: '缩略图',
				width: 100,
				dataIndex: 'st_fileurl',
				render: (url: string, record: object) => (
					<img onClick={() => gethandlePreview(record)} style={{width: '90px',cursor:'pointer'}} src={`${idMap[record.st_type] === '文章' ? '//m.elongstatic.com/cdc/com-static/pic.png' : idMap[record.st_type] === 'URL' ? '//m.elongstatic.com/cdc/com-static/icon_url.png' : idMap[record.st_type] === '文件' ? '//m.elongstatic.com/cdc/com-static/icon_file.png' : ''}`}/>
				)
			},
			{
				title: '审核状态',
				dataIndex: 'st_review',
				width: 140,
				render: (state: string, record: object) => {
					return (
						<a onClick={() => {batchReview(record)}} className={`check-state ${state === 'r4' ?'cdc-danger' : state === 'r0' ? 'cdc-success':'cdc-warning'}`}>
							{state==='r0' ? GLOBAL.tradeReviewState[state] : GLOBAL.tradeReviewState[state]+' ('+GLOBAL.tradeState[record.st_review_node]+')'}
						</a>
					)
				},
			},
			{
				title: '操作',
				dataIndex: 'name',
				width: 170,
				ellipsis: true,
				render: (name: string, record: object) => {
					return (
						<div className="operate">
							<div className="top">
								{
									(record.st_create_work_id === userInfo.userid || btnAuth.includes('workReview()') ) && ((record.st_review_node == '6'&& record.st_review =='r1') || record.st_review == 'r4') ?
										<span onClick={() => revokeReview(record.id)}>撤回</span> : <span className="gray">撤回</span>
								}
								{
									(record.st_create_work_id === userInfo.userid || btnAuth.includes('workEdit()') ) && ((record.st_review_node == '6'&& record.st_review =='r1') || record.st_review == 'r4') ?
										<span onClick={() => update(record)}>编辑</span> : <span className="gray">编辑</span>
								}
								<span onClick={() => getDetails(record.id,2)}>日志</span>
								{
									(record.st_create_work_id === userInfo.userid && record.st_review !='r0') || btnAuth.includes('workDel()') ?
										<span onClick={() => del(record.id)}>删除</span>
										:
										<span className="gray">删除</span>
								}
							</div>
							<div className="bottom">
								<span onClick={() => {this.props.history.push(`/main/content/details/${record.id}/4`);this.jumpBeforeRecord()}}>审核详情</span>
							</div>
						</div>
					)
				},
			},
		]
		const columnsNew = [
			{
				title: '项目名称',
				dataIndex: 'projectName',
				minWidth: 160,
				ellipsis: true,
			},
			{
				title: '内容形式',
				textWrap: 'word-break',
				width: 200,
				ellipsis: true,
				render: (record: Object) => {
					const map = {
						richText: '图文审核',
						urlAddress: '网页审核',
						uploadAnnex: '文件',
					}
					const types: string[] = Object.entries(map).reduce((prev, [key, value]) => {
						if (record[key]) {
							prev.push(map[key])
						}
						return prev
					}, [])
					return (
						<span>{types.join('/')}</span>
					)
				},
			},
			{
				title: '创建人',
				dataIndex: 'userName',
				width: 100
			},
			{
				title: '发布时间',
				dataIndex: 'createTime',
				textWrap: 'word-break',
				width: 180,
				ellipsis: true,
				render: (val: string) => {
					return (
						<div>{moment(val).format('YYYY-MM-DD HH:mm:ss')}</div>
					)
				},
			},
			{
				title: '更新时间',
				dataIndex: 'updateTime',
				textWrap: 'word-break',
				width: 180,
				ellipsis: true,
				render: (val: string) => {
					return (
						<div>{moment(val).format('YYYY-MM-DD HH:mm:ss')}</div>
					)
				},
			},
			{
				title: '审核状态',
				dataIndex: 'approveStatus',
				width: 120,
				render: (state: string, record: object) => {
					return (
						<div style={{color: approveDict[state]?.color}}>{approveDict[state]?.text}</div>
					)
					// return (
					// 	<a onClick={() => {batchReview(record)}} className={`check-state ${state === 'r4' ?'cdc-danger' : state === 'r0' ? 'cdc-success':'cdc-warning'}`}>
					// 		{state==='r0' ? GLOBAL.tradeReviewState[state] : GLOBAL.tradeReviewState[state]+' ('+GLOBAL.tradeState[record.st_review_node]+')'}
					// 	</a>
					// )
				},
			},
			{
				title: '操作',
				dataIndex: 'name',
				width: 140,
				ellipsis: true,
				render: (name: string, record: any) => {
					return (
						<div className="operate">
						<div className="top">
							{/* {
								(record.st_create_work_id === userInfo.userid || btnAuth.includes('workReview()') ) && ((record.st_review_node == '6'&& record.st_review =='r1') || record.st_review == 'r4') ?
									<span onClick={() => revokeReview(record.id)}>撤回</span> : <span className="gray">撤回</span>
							} */}
							{/* {
								(record.st_create_work_id === userInfo.userid || btnAuth.includes('workEdit()') ) && ((record.st_review_node == '6'&& record.st_review =='r1') || record.st_review == 'r4') ?
									<span onClick={() => update(record)}>编辑</span> : <span className="gray">编辑</span>
							} */}
							{/* <span onClick={() => getDetails(record.id,2)}>日志</span> */}
							{/* {
								(record.st_create_work_id === userInfo.userid && record.st_review !='r0') || btnAuth.includes('workDel()') ?
									<span onClick={() => del(record.id)}>删除</span>
									:
									<span className="gray">删除</span>
							} */}
							{/* <span onClick={() => handleDelete(record.id)}>删除</span> */}
							<span onClick={() => {this.props.history.push(`/main/content/detailsnew/${record.businessKey}/4`);this.jumpBeforeRecord()}}>审核详情</span>
						</div>
						{/* <div className="bottom">

						</div> */}
					</div>
					)
				}
			}
		]
		const rowSelection = {
			columnWidth: 36,
			selectedRowKeys,
			onChange: this.onSelectChange,
		}
		return (
			<div className="library-wrap">
				<BreadcrumbLink/>
				{/* <div className="search-wrap" style={{padding: '20px 0 0 20px'}}>
					<HeaderSearch getInfoForm={localStorage.getItem('jumpBeforeParams')} btnAuth={btnAuth} onSearch={this.getSearch.bind(this)} addMedia={addMedia}/>
				</div> */}
				<div className="content-wrap">
					<div>
						<div className="hd" style={{position: 'relative', padding: 0}}>
							<div className="fl title" style={{height: 80}}>品牌曝光 {selectedRowKeys.length > 0 ? <span>（已选择{selectedRowKeys.length}条）</span>: ''}</div>
							<div className="fr content-wrap-option-btn" style={{ display: 'flex', alignItems: 'center' }}>
								{btnAuth.includes('batchDelete()') && <Tooltip title="批量删除">
									<span className="opt del" onClick={() => del()}></span>
								</Tooltip>}
								{btnAuth.includes('batchReview()') && <Tooltip title="批量审核通过">
									<span className="opt pass" onClick={() => batchReview()}></span>
								</Tooltip>}
							</div>
							<Button className='addmedia-btn' type="primary" onClick={addMedia}>上传内容</Button>
						</div>
					</div>
					<div>
						<Table
							className=""
							rowSelection= {rowSelection}
							columns= {columnsNew}
							dataSource= {dataList}
							rowKey="id"
							pagination={false}
						/>
						<Pagination className="list-common-pagination"  {...pagination}/>
					</div>
					{/* 预览 */}
					<FilePreview
						{...previewInfo}
						visible={previewVisible}
						handleVisible={this.handlePreviewVisible}
					/>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.baseInfo.userInfo,
	}
}

export default connect(mapStateToProps, null)(NewMedia)
